module.exports = __webpack_public_path__ + "static/media/next.afac6b16.svg";